import SummaryCardCallHistoryComponent from './SummaryCardCallHistory.component';

export default SummaryCardCallHistoryComponent;
